import { createApp } from 'vue';
import App from './app.vue';
import i18n from './i18n';
import router from './router';

import '/app/assets/sass/preset.css';
import '/app/assets/sass/app.scss';

const app = createApp(App);

app.use(i18n);
app.use(router);

// install plugins
const plugins = import.meta.glob('./plugins/*.js', { eager: true });

Object.values(plugins)
      .forEach(i => (i.default.install || i.install)({ app, router }));

app.mount('#app');